import { Answers, QuestionCodes } from "../../UserJourney/UserJourneyMap";
import CoreUtils from "../../core/coreUtils";

// Question Showcase Survey — Guideline
// This is a demo survey showing all question types. The scoring is simple:
// - Only the Choice questions (stacked, sidebyside, large, small) and the experience rating contribute to score.
// - Experience rating: Excellent=5, Good=4, Average=3, Poor=2, Terrible=1
// - Other choice questions: 1 point each for answering
// - Score range: 0-12 mapped to low/moderate/high engagement

const ExperienceScoreMap = [
    { answer: Answers.questionShowcase.excellent, score: 5 },
    { answer: Answers.questionShowcase.good, score: 4 },
    { answer: Answers.questionShowcase.average, score: 3 },
    { answer: Answers.questionShowcase.poor, score: 2 },
    { answer: Answers.questionShowcase.terrible, score: 1 }
];

const totalRiskLevel = 3;

const SisuQuestionShowcaseGuidelineDefinition = [
    {
        min: 0,
        max: 4,
        key: "low",
        label: "ranges.questionShowcaseLow",
        rangeInfo: "0-4",
        riskLevel: 1 / (totalRiskLevel + 1)
    },
    {
        min: 5,
        max: 8,
        key: "moderate",
        label: "ranges.questionShowcaseModerate",
        rangeInfo: "5-8",
        riskLevel: 2 / (totalRiskLevel + 1)
    },
    {
        min: 9,
        max: 12,
        key: "high",
        label: "ranges.questionShowcaseHigh",
        rangeInfo: "9-12",
        riskLevel: 3 / (totalRiskLevel + 1)
    }
];

function CalcScore(answers) {
    let score = 0;

    // 1 point for answering each choice question
    if (answers[QuestionCodes.qsChoiceStacked]) score += 1;
    if (answers[QuestionCodes.qsChoiceSideBySide]) score += 1;
    if (answers[QuestionCodes.qsChoiceSmall]) score += 1;
    if (answers[QuestionCodes.qsChoiceSideBySideLarge]) score += 1;
    if (answers[QuestionCodes.qsChoiceSideBySideTriple]) score += 1;
    if (answers[QuestionCodes.qsChoiceScroll]) score += 1;

    // Experience rating contributes 1-5 points
    const experienceAnswer = answers[QuestionCodes.qsChoiceLarge];
    if (experienceAnswer) {
        const match = ExperienceScoreMap.find(obj => obj.answer === experienceAnswer);
        score += match ? match.score : 0;
    }

    // 1 point for each number answered
    if (answers[QuestionCodes.qsNumber]) score += 1;

    return Math.min(score, 12);
}

function SisuGuideline(score) {
    return SisuQuestionShowcaseGuidelineDefinition.find(gl => CoreUtils.isWithin(score, gl.min, gl.max));
}

function questionShowcase(answers) {
    const score = CalcScore(answers);
    const guideline = SisuGuideline(score);
    const rangeInfo = guideline.rangeInfo;
    const key = guideline.key;
    const ranges = SisuQuestionShowcaseGuidelineDefinition;
    const label = guideline.label;
    return { score, rangeInfo, key, ranges, label };
}

const RiskName = "QUESTION_SHOWCASE";
const RiskCode = "QUESTION_SHOWCASE";
const GuidelineName = "SiSU Question Showcase Guideline";
const GuidelineCode = "SISU_QUESTION_SHOWCASE";

export {
    CalcScore,
    SisuGuideline,
    questionShowcase,
    SisuQuestionShowcaseGuidelineDefinition,
    RiskName,
    RiskCode,
    GuidelineName,
    GuidelineCode
};
